/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  IStakingTierManager,
  IStakingTierManagerInterface,
} from "../../../contracts/interfaces/IStakingTierManager";

const _abi = [
  {
    inputs: [],
    name: "StakingManager_LargeTierList",
    type: "error",
  },
  {
    inputs: [],
    name: "StakingManager_TierListEmpty",
    type: "error",
  },
  {
    inputs: [],
    name: "StakingManager_TierNotDefined",
    type: "error",
  },
  {
    inputs: [],
    name: "StakingManager_TierNotFound",
    type: "error",
  },
  {
    inputs: [],
    name: "StakingManager_TierNotSorted",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
    ],
    name: "TierRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minStaked",
        type: "uint256",
      },
    ],
    name: "TierSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "TiersCleared",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "getStakedAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "getTier",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "level",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minStaked",
            type: "uint256",
          },
        ],
        internalType: "struct IStakingTierManager.TierWithLevel",
        name: "tier",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "lock",
    outputs: [
      {
        internalType: "contract ILock",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
    ],
    name: "removeTier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minStaked",
        type: "uint256",
      },
    ],
    name: "setTier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "minStaked",
            type: "uint256",
          },
        ],
        internalType: "struct IStakingTierManager.StakingTier[]",
        name: "tiers",
        type: "tuple[]",
      },
    ],
    name: "setTokenTiers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "stakingTiers",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "level",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minStaked",
            type: "uint256",
          },
        ],
        internalType: "struct IStakingTierManager.TierWithLevel[]",
        name: "tiers",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

export class IStakingTierManager__factory {
  static readonly abi = _abi;
  static createInterface(): IStakingTierManagerInterface {
    return new Interface(_abi) as IStakingTierManagerInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): IStakingTierManager {
    return new Contract(
      address,
      _abi,
      runner
    ) as unknown as IStakingTierManager;
  }
}
